<template>
  <v-fade-transition mode="out-in">
    <v-app>
      <router-view />
      <notify ref="notify" />
      <confirm ref="confirm" />
    </v-app>
  </v-fade-transition>
</template>

<script>
  import Notify from './../../UIComponents/Notify'
  import Confirm from './../../UIComponents/Confirm'

  export default {
    metaInfo () {
      return {
        title: 'Himydata',
      }
    },
    components: {
      Confirm,
      Notify,
    },
  }
</script>

<style lang="scss">
    html,body,.v-application{
        height:100%;
    }
</style>
